export default "__VITE_ASSET__BfThuz40__"